import React from 'react';
import { color, font, radius, tint } from '../tokens';

/**
 * Session type chip. Part of the session card and never optional — the handoff
 * calls it out explicitly ("The type chip is not optional"), because tournament
 * and training blocks carry different expectations for a family and the chip is
 * the only thing that distinguishes them at a glance.
 */

export const TYPES = {
  training: { label: 'Training', fg: color.textSecondary, bg: 'transparent', bd: color.border },
  tournament: { label: 'Tour', fg: color.secondary, bg: tint.yellow, bd: tint.yellowBorder },
  cancelled: { label: 'Cancelled', fg: color.error, bg: tint.red, bd: tint.redBorder },
  makeup: { label: 'Makeup', fg: color.primary, bg: tint.green, bd: color.primary },
  diagnostic: { label: 'Diagnostic', fg: color.primary, bg: tint.green, bd: color.primary },
  // Sprint 9 pins (docs/portal/TEAM.md, contract v1.7 + v1.7.1): specialist
  // sessions with Phil (performance, GROUP format at a cap of 6 — the
  // owner's ruling retired the '1-on-1' wording) and Yannick (mental game,
  // true 1:1). Same green treatment as makeup/diagnostic - a specialist
  // session is a positive-value booking, not a caution/error state -
  // distinguished from those by label text alone rather than a new tint.
  phil: { label: 'Performance', fg: color.primary, bg: tint.green, bd: color.primary },
  mental: { label: 'Mental game', fg: color.primary, bg: tint.green, bd: color.primary },
  // Contract v2.0 pin J: the Saturday 2-4 PM college / Elite Am / Mid Am
  // block - display-only, never bookable here. Neutral, like training.
  adult: { label: 'Adults', fg: color.textSecondary, bg: 'transparent', bd: color.border },
};

export default function TypeChip({ type = 'training', style }) {
  const t = TYPES[type] || TYPES.training;
  return (
    <span
      style={{
        font: `600 9px ${font.body}`,
        letterSpacing: '.06em',
        textTransform: 'uppercase',
        padding: '3px 7px',
        borderRadius: radius.badge,
        color: t.fg,
        background: t.bg,
        border: `1px solid ${t.bd}`,
        whiteSpace: 'nowrap',
        flex: 'none',
        ...style,
      }}
    >
      {t.label}
    </span>
  );
}
